import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m4.5 2 .672 1.828L7 4.5l-1.828.672L4.5 7l-.672-1.828L2 4.5l1.828-.672zm7 11 .672 1.828L14 15.5l-1.828.672L11.5 18l-.672-1.828L9 15.5l1.828-.672zm-.35-9.721a.44.44 0 0 0-.195-.22.47.47 0 0 0-.559.079l-7.272 7.437a.423.423 0 0 0-.087.474.44.44 0 0 0 .168.192.47.47 0 0 0 .25.071h3.02l-1.637 5.121a.42.42 0 0 0 .011.289c.038.092.106.169.195.219a.47.47 0 0 0 .56-.079l7.272-7.437a.422.422 0 0 0 .087-.474.44.44 0 0 0-.168-.192.47.47 0 0 0-.25-.071h-3.02l1.637-5.12a.42.42 0 0 0-.011-.29",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }